<template>
    <div class="nav">
        <div class="pc">
            <router-link to='/'>
                <img class="logo" :src="logoUrl" alt="">
            </router-link>
            <div class="navbox">
                <div class="langbox">
                    <div :class="{'lang_item': true, 'darkStyle': navstyle === 'dark', 'lightStyle': navstyle !== 'dark', 'lang_passive': lang !== 0}" @click="onChangeLang(0)">中文</div>
                    <div :class="{'lang_divider': true, 'darkStyle': navstyle === 'dark', 'lightStyle': navstyle !== 'dark'}">|</div>
                    <div :class="{'lang_item': true, 'darkStyle': navstyle === 'dark', 'lightStyle': navstyle !== 'dark', 'lang_passive': lang !== 1}" @click="onChangeLang(1)">ENGLISH</div>
                </div>
                <div class="menubox">
                    <div :class="{'nav_item': true, 'darkStyle': navstyle === 'dark', 'lightStyle': navstyle !== 'dark'}" v-for="(item, index) in nav" :key="index" @mouseover="onMouseOver(index)" @mouseout="onMouseOut">
                        <div class="nav_item_title" v-if="item.subtitle.length > 0">{{item.title[lang]}}</div>
                        <div class="nav_item_title nav_item_click" v-if="item.subtitle.length === 0" @click="toPage(item.url)">{{item.title[lang]}}</div>
                        <transition name="slide">
                            <div class="sub_nav" :style="{width: item.width + 'px'}" v-show="currentIndex === index">
                                <router-link :to="subitem.url" style="text-decoration: none;" v-for="(subitem, subindex) in item.subtitle" :key="subindex">
                                    <div class="subtitle" >
                                        {{subitem.title[lang]}}
                                    </div>
                                </router-link>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="mobile">
            <div class="navIcon" @click="onOpenSideNav">
                <img class="img_widthfix" :src="menuIcon" alt="">
            </div>
            <div class="sidenavContainer" id="sidenavContainer" @touchmove.prevent v-show="showSideNav" @click="onCloseSideNav">
                <div class="sidenav">
                    <router-link to='/'>
                        <img class="side_logo" src="../assets/images/deansel_logo_white.png" alt="">
                    </router-link>
                    <div class="side_langbox">
                        <div :class="{'lang_item lightStyle': true, 'lang_passive': lang !== 0}" @click="onChangeLang(0)">中文</div>
                        <div :class="{'lang_divider': true, 'darkStyle': navstyle === 'dark', 'lightStyle': navstyle !== 'dark'}">|</div>
                        <div :class="{'lang_item lightStyle': true, 'lang_passive': lang !== 1}" @click="onChangeLang(1)">ENGLISH</div>
                    </div>
                    <div class="sidenavBox">
                        <div class="sidenav_item" v-for="(item, index) in nav" :key="index">
                            <div v-if="item.subtitle.length > 0" class="sidenav_item_title" @click="changNavState(index)">
                                <div>{{item.title[lang]}}</div>
                                <div :class="currentIndex === index ? 'drop-up' : 'drop-down'"></div>
                            </div>
                            <div v-if="item.subtitle.length === 0" class="sidenav_item_title sidenav_item_title_click" @click="toPage(item.url)">
                                <div>{{item.title[lang]}}</div>
                            </div>
                            <transition name="slide">
                                <div class="sub_sidenav" v-show="currentIndex === index">
                                    <router-link :to="subitem.url" style="text-decoration: none;" v-for="(subitem, subindex) in item.subtitle" :key="subindex">
                                        <div class="side_subtitle" >
                                            {{subitem.title[lang]}}
                                        </div>
                                    </router-link>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {navText} from '@/js/text.js'
export default {
    props: {
        navstyle: String
    },
    data () {
        return {
            nav: navText,
            currentIndex: null,
            showSideNav: false
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        },
        logoUrl () {
            return this.navstyle === 'dark' ? require('../assets/images/deansel_logo.png') : require('../assets/images/deansel_logo_white.png')
        },
        menuIcon () {
            return this.navstyle === 'dark' ? require('../assets/images/icon_menu_black.png') : require('../assets/images/icon_menu_white.png')
        }
    },
    methods: {
        onChangeLang (lang) {
            this.$store.commit('setLang', lang)
        },
        toPage (url) {
            if (this.$route.path !== url) {
                this.$router.push({path: url})
            }
            
        },
        onMouseOver (index) {
            this.currentIndex = index
        },
        onMouseOut () {
            this.currentIndex = null
        },
        onCloseSideNav (e) {
            if (e.target.id === 'sidenavContainer') {
                this.showSideNav = false
            }
        },
        onOpenSideNav () {
            this.showSideNav = true
        },
        changNavState (index) {
            this.currentIndex = this.currentIndex === index ? null : index
        }
    }
}
</script>

<style scoped>
.pc {
    display: block;
}
.mobile {
    display: none;
}
.nav {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.logo {
    height: 20px;
    position: absolute;
    top: 24px;
    left: 60px;
}
.navbox {
    position: absolute;
    top: 20px;
    right: 60px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
}
.langbox {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
.side_langbox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
.lang_divider {
    color: #fff;
    margin: auto 10px;
}
.lang_passive {
    opacity: 0.5;
}
.lang_item:hover {
    cursor: pointer;
    text-decoration: underline;
}
.menubox {
    display: flex;
    align-items: center;
}
.darkStyle {
    color: #000;
}
.lightStyle  {
    color: #fff;
}
.nav_item {
    box-sizing: border-box;
    padding: 0 10px;
    position: relative;
}
.nav_item_title {
    font-weight: bold;
}
.nav_item_click:hover {
    cursor: pointer;
}
.nav_item:hover {
    background: #fff;
    color: #000;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}
.sub_nav {
    width: 170px;
    position: absolute;
    top: 40px;
    left: 0;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
    transform-origin: top center;
}
.subtitle {
    width: 100%;
    padding: 12px 10px;
    line-height: 1.2;
    text-align: left;
    box-sizing: border-box;
    background: #fff;
    color: #000;
    font-size: 14px;
    text-decoration: none;
}
.subtitle:hover {
    text-decoration: underline;
}
.slide-enter-active {
  transition: all .3s ease;
}
.slide-leave-active {
    transition: all 0s ease;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scaleY(0);
}
.navIcon {
    width: 30px;
    height: 30px;
    /* border: solid 1px #d8d8d8; */
    /* border-radius: 100%; */
    /* background: #fff; */
    overflow: hidden;
    position: fixed;
    z-index: 90;
    top: 24px;
    left: 24px;
}
.navIcon:hover {
    cursor: pointer;
}
.sidenavContainer {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
}
.sidenav {
    width: 260px;
    height: 100vh;
    background: #32343B;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
}
.side_logo {
    height: 20px;
    margin: 24px auto 20px auto;
}
.sidenavBox {
    width: 180px;
    text-align: center;
    line-height: 2;
}
.sidenav_item {
    padding: 10px auto;
    box-sizing: border-box;
    border-bottom: #d8d8d8 solid 1px;
}
.sidenav_item:nth-last-child(1) {
    border: none;
}
.sidenav_item_title {
    font-weight: bold;
    position: relative;
    line-height: 3;
}
.sidenav_item_title_click:hover {
    cursor: pointer;
    text-decoration: underline;
}
.drop-down {
    width: 6px;
    height: 6px;
    position: absolute;
    right: 50px;
    top: 12px;
    border:#fff solid;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
}
.drop-up {
    width: 6px;
    height: 6px;
    position: absolute;
    right: 50px;
    top: 16px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
.sub_sidenav {
    margin-bottom: 10px;
    transform-origin: top center;
}
.side_subtitle {
    color: #fff;
    line-height: 1.2;
    margin: 10px auto;
}
.side_subtitle:hover {
    cursor: pointer;
    text-decoration: underline;
}
@media screen and (max-width: 756px) {
    .pc {
        display: none;
    }
    .mobile {
        display: block;
    }
}
</style>
